import React, { useCallback, useRef } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { FileListDataTable } from "./FileListDataTable";

// fileType:  image, archive, pdf, video
const FilePicker = React.memo(
  ({ open, onClose, onConfirm, title, single, target, checkedList, fileType="image", filter=v => true }) => {
    const { t } = useTranslation();
    const tableRef = useRef();
    const handleConfirm = useCallback(() => {
      if (onConfirm) {
        onConfirm(tableRef.current.getSelectedRows());
      }
      onClose();
    });

    return (
      <Modal
        open={open}
        onClose={onClose}
        onConfirm={handleConfirm}
        title={title}
        width={1200}
        height={800}
      >
        <FileListDataTable
          single={single}
          target={target}
          checkedList={checkedList}
          fileType={fileType}
          ref={tableRef}
          filter={filter}
        />
      </Modal>
    );
  }
);

export default FilePicker;
